// TOP LEVEL IMPORTS
import React from 'react';
import { Link } from 'react-router-dom';
// MODULES
import AccountHelpers from 'lib/helpers/AccountHelpers';
// ANTD
import Menu from 'antd/lib/menu';
import 'antd/lib/menu/style/css';
import Icon from 'components/common/Icon';
import Dropdown from 'antd/lib/dropdown';
import 'antd/lib/dropdown/style/css';
import Avatar from 'antd/lib/avatar';
import 'antd/lib/avatar/style/css';
import logActivity from 'ApolloClient/Mutations/logActivity';
import { graphql } from 'react-apollo';
// COMPONENTS
import HelpModal from 'components/common/HelpModal';

// CONSTANTS & DESTRUCTURING
// ====================================

// EXPORTED COMPONENT
// ====================================
export class DropdownButton extends React.Component {
  handleClick = async e => {
    this.setState({ open: false });

    if (e.key === 'logout') {
      AccountHelpers.handleLogout(this, this.props);
      // log the activity server side
      await this.props.logActivity({
        variables: {
          params: {
            userId: this.props.currentUser._id,
            eventType: 'logout',
            date: new Date(),
            userAgent: window.navigator.userAgent,
          },
        },
      });
      return window.location.reload();
    }

    if (e.key === 'help') {
      let win = window.open('https://www.zendesk.com', '_blank');
      return win.focus();
    }

    this.props.history.push(e.key);

    return this.setState({ current: e.key });
  };

  renderDropdown = () => (
    <Menu onClick={this.handleClick} style={{ lineHeight: '34px', width: 145 }}>
      <Menu.Item key="/account">
        <Icon type="user" style={{ marginRight: 7 }} />
        Account
      </Menu.Item>
      <Menu.Item key="/dashboards">
        <Icon type="layout" style={{ marginRight: 7 }} />
        Dashboards
      </Menu.Item>
      <Menu.Item key="help" className="dropdown-item">
        <Icon type="question" style={{ marginRight: 7 }} />
        Help
        <HelpModal />
      </Menu.Item>
      <Menu.Item key="logout">
        <Icon type="logout" style={{ marginRight: 7 }} />
        Logout
      </Menu.Item>
    </Menu>
  );

  render() {
    const overlay = this.renderDropdown();

    return (
      <span style={{ marginRight: 6 }}>
        <Dropdown overlay={overlay} trigger={['click', 'hover']}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {/* <Avatar size="small" icon="user" style={{ marginRight: 4 }} /> */}
            <Link to="/account" style={{ fontSize: 14 }}>
              {/* <Icon type="user" style={{ marginRight: 5, fontWeight: 600 }} /> */}
              MY ACCOUNT
            </Link>
          </div>
        </Dropdown>
      </span>
    );
  }
}

// EXPORT
// ====================================
export default graphql(logActivity, { name: 'logActivity' })(DropdownButton);



// WEBPACK FOOTER //
// ./src/components/layout/BlankLayout/Header/DropdownButton/index.js